import React, { Fragment, useState, useEffect } from "react";
import { TextField, MenuItem, Select, InputLabel } from "@material-ui/core";
import PickupSelector from "../giftshop/PickupSelector";
import CollapsedContainer from "../assets/CollapsedContainer";
import Loading from "../assets/Loading";

const appId = "sq0idp-Zt66ubgBvwkuijlDQBQGpQ";
const locationId = React.isDevelopment ? "1D1W0QXPXSXTF" : "EENN0H8C8XBVN";

const states = {
  AK: "Alaska",
  AL: "Alabama",
  AR: "Arkansas",
  AS: "American Samoa",
  AZ: "Arizona",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DC: "District of Columbia",
  DE: "Delaware",
  FL: "Florida",
  GA: "Georgia",
  GU: "Guam",
  HI: "Hawaii",
  IA: "Iowa",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  MA: "Massachusetts",
  MD: "Maryland",
  ME: "Maine",
  MI: "Michigan",
  MN: "Minnesota",
  MO: "Missouri",
  MS: "Mississippi",
  MT: "Montana",
  NC: "North Carolina",
  ND: " North Dakota",
  NE: "Nebraska",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NV: "Nevada",
  NY: "New York",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  PR: "Puerto Rico",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VA: "Virginia",
  VI: "Virgin Islands",
  VT: "Vermont",
  WA: "Washington",
  WI: "Wisconsin",
  WV: "West Virginia",
  WY: "Wyoming",
};

class PaymentForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      card: null,
      disabled: false,
      status: null,
      statusBarHidden: true,
      fullfilment: {
        type: this.props.isPickup ? "PICKUP" : "SHIPMENT",
        state: "PROPOSED",
        shipment_details: { recipient: {} },
        pickup_details: { recipient: {}, pickup_at: "" },
      },
      address_line_1: "",
      address_line_2: "",
      locality: "",
      sublocality: "",
      postal_code: "",
      isLoading: false
    };

    this.handlePaymentMethodSubmission =
      this.handlePaymentMethodSubmission.bind(this);
  }
  async componentDidMount() {
    if (!window.Square) {
      throw new Error("Square.js failed to load properly");
    }

    let payments;
    try {
      payments = window.Square.payments(appId, locationId);
    } catch (e) {
      console.log("Missing Square Credentials!" + e);
      const statusContainer = document.getElementById(
        "payment-status-container"
      );
      statusContainer.className = "missing-credentials";
      statusContainer.style.visibility = "visible";
      return;
    }

    let card;
    try {
      card = await this.initializeCard(payments);
    } catch (e) {
      console.error("Initializing Card failed", e);
      return;
    }

    this.setState({
      card: card,
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isPickup !== this.props.isPickup) {
      let fullfilment = this.state.fullfilment;

      fullfilment.type = this.props.isPickup ? "PICKUP" : "SHIPMENT";
      fullfilment.state = "PROPOSED";

      if (this.props.isPickup) {
        fullfilment.pickup_details = {};
        fullfilment.pickup_details.recipient =
          fullfilment.shipment_details.recipient;
        fullfilment.pickup_details.recipient.address = null;
        fullfilment.shipment_details = null;
        this.setState({
          address_line_1: "",
          address_line_2: "",
          locality: "",
          sublocality: "",
          postal_code: "",
        });
      } else {
        fullfilment.shipment_details = {};
        fullfilment.shipment_details.recipient =
          fullfilment.pickup_details.recipient;
        fullfilment.pickup_details = null;
      }
      this.setState({
        fullfilment: fullfilment,
      });
    }
  }

  updateCustomerInfo(event, type, isAddress = false) {
    let fullfilment = this.state.fullfilment;
    let value = event.target.value;

    if (
      fullfilment[
        this.props.isPickup ? "pickup_details" : "shipment_details"
      ] == null
    ) {
      fullfilment[this.props.isPickup ? "pickup_details" : "shipment_details"] =
        {};
    }

    if (this.props.isPickup) {
      if (fullfilment.pickup_details.recipient == null) {
        fullfilment.pickup_details.recipient = {};
      }
      fullfilment.pickup_details.recipient[type] = value;
    } else {
      if (fullfilment.shipment_details.recipient == null) {
        fullfilment.shipment_details.recipient = {};
      }

      if (isAddress) {
        this.setState({
          [type]: value,
        });
        if (fullfilment.shipment_details.recipient.address == null) {
          fullfilment.shipment_details.recipient.address = {};
        }
        fullfilment.shipment_details.recipient.address[type] = value;
      } else {
        fullfilment.shipment_details.recipient[type] = value;
      }
    }

    console.log(fullfilment);

    if (this.props.fullfilmentCallback != null)
      this.props.fullfilmentCallback(fullfilment);

    this.setState({
      fullfilment: fullfilment,
    });
  }

  async handlePaymentMethodSubmission(event, paymentMethod) {
    event.preventDefault();

    try {
      // disable the submit button as we await tokenization and make a payment request.
      this.setState({ disabled: true });
      const token = await this.tokenize(paymentMethod);
      const paymentResults = await this.createPayment(token);
      this.displayPaymentResults("SUCCESS");
      console.debug("Payment Success", paymentResults);
      console.log(paymentResults);
      window.location.replace("/giftshop/confirmation?id=" + paymentResults.id);
    } catch (e) {
      this.setState({ disabled: false, isLoading: false });
      this.displayPaymentResults(`FAILURE: ${e.message}`);
      console.error(e.message);
    }
  }

  async initializeCard(payments) {
    const card = await payments.card();
    await card.attach("#card-container");

    return card;
  }

  async createPayment(token) {
    let shippingItem = this.props.shippingItem;
    const body = JSON.stringify({
      paymentSourceId: token,
      order: !this.props.isPickup
        ? { ...this.props.orderItems, shippingItem }
        : this.props.orderItems,
      fullfilment: this.state.fullfilment,
    });

    const paymentResponse = await fetch("/giftshop/cart/payment", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body,
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Payment Results: " + data);
        if (data.error == null) {
          return data;
        } else {
          throw new Error(data.error);
        }
      });
    return paymentResponse;
  }

  async tokenize(paymentMethod) {
    const tokenResult = await paymentMethod.tokenize();
    if (tokenResult.status === "OK") {
      return tokenResult.token;
    } else {
      let errorMessage = `Tokenization failed with status: ${tokenResult.status}`;
      if (tokenResult.errors) {
        errorMessage += ` and errors: ${JSON.stringify(tokenResult.errors)}`;
      }

      throw new Error(errorMessage);
    }
  }

  // status is either SUCCESS or FAILURE;
  displayPaymentResults(status) {
    this.setState({
      status: status,
      statusBarHidden: false,
    });
  }

  getStateOptions() {
    let menuItems = [];
    Object.keys(states).forEach((key) => {
      menuItems.push(<MenuItem value={key}>{states[key]}</MenuItem>);
    });
    return menuItems;
  }

  setPickupTime(time) {
    console.log(time);
    let f = this.state.fullfilment;
    f.pickup_details.pickup_at = time;

    this.setState({
      fullfilment: f,
    });
  }

  render() {
    return (
      <Fragment>
        {this.state.isLoading ? <Loading /> : <></>}
        <CollapsedContainer
          isCollapsed={this.props.checkoutState != "shipping"}
          label="Shipping/Pickup"
          content={
            <Fragment>
              <div>
                <TextField
                  required
                  id="outlined-required"
                  label="Full Name"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  size="large"
                  onChange={(event) =>
                    this.updateCustomerInfo(event, "display_name")
                  }
                />
                <TextField
                  required
                  id="outlined-required"
                  label="Email"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  size="large"
                  onChange={(event) =>
                    this.updateCustomerInfo(event, "email_address")
                  }
                />
                <TextField
                  required
                  id="outlined-required"
                  label="Phone"
                  type="phone"
                  autoComplete="phone"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  size="large"
                  onChange={(event) =>
                    this.updateCustomerInfo(event, "phone_number")
                  }
                />
                {!this.props.isPickup ? (
                  <Fragment>
                    <TextField
                      required
                      id="outlined-required"
                      label="Street Address"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      size="large"
                      onChange={(event) =>
                        this.updateCustomerInfo(event, "address_line_1", true)
                      }
                      value={this.state.address_line_1}
                    />
                    <TextField
                      required
                      id="outlined-required"
                      label="Apartment/Unit Number"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      size="large"
                      onChange={(event) =>
                        this.updateCustomerInfo(event, "address_line_2", true)
                      }
                      value={this.state.address_line_2}
                    />
                    <TextField
                      required
                      id="outlined-required"
                      label="City"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      size="large"
                      onChange={(event) =>
                        this.updateCustomerInfo(event, "locality", true)
                      }
                      value={this.state.locality}
                    />
                    <InputLabel id="state-label">State</InputLabel>
                    <Select
                      labelId="state-label"
                      required
                      autoComplete="address-level1"
                      label="State"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      onChange={(event) =>
                        this.updateCustomerInfo(event, "sublocality", true)
                      }
                      value={this.state.sublocality}
                    >
                      {this.getStateOptions()}
                    </Select>
                    <TextField
                      required
                      id="outlined-required"
                      label="Zip"
                      type="postal-code"
                      autoComplete="postal-code"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      size="large"
                      onChange={(event) =>
                        this.updateCustomerInfo(event, "postal_code", true)
                      }
                      value={this.state.postal_code}
                    />
                  </Fragment>
                ) : (
                  <PickupSelector
                    pickupTimeCallback={this.setPickupTime.bind(this)}
                  />
                )}
              </div>
            </Fragment>
          }
        />
        <CollapsedContainer
          isCollapsed={this.props.checkoutState != "payment"}
          label="Payment"
          content={
            <Fragment>
              <form id="payment-form">
                <div id="card-container"></div>
                <div
                  className="purple-button"
                  id="card-button"
                  type="button"
                  onClick={(event) => {
                    this.setState({isLoading: true});
                    this.handlePaymentMethodSubmission(event, this.state.card);
                  }
                  }
                  disabled={this.state.disabled}
                >
                  Complete Order
                </div>
              </form>
              <div id="payment-status-container" hidden={this.statusBarHidden}>
                {this.state.status}
              </div>
            </Fragment>
          }
        />
      </Fragment>
    );
  }
}

export default PaymentForm;
